import { gql } from '@apollo/client';

export const RESOURCE_QUERY = gql`
    query( $resourceID: UUID! ) {
        resource(resourceID: $resourceID) {
            node{
                id
                name
                type
                tagIds
                description
                image
                isFeatured
                isPublished
                resourceLocalizations{
                    edges{
                        node{
                            id
                            localeCode
                            isDefault
                            resourceFileId
                            name
                            description
                            resourceUrlId
                            resourceUrl {
                                node {
                                    id
                                    url
                                }
                            }
                            resourceFile{
                                node{
                                    id
                                    genericFile
                                    lxpFile
                                }
                            }
                        }
                    }
                }
                segmentIds
                learningProfileIds
                employeeLocaleIds
                localeIds
                companyRelationshipIds
                brandIds
                productIds
            }
        }
    }
`;
